export const actionTypes = {
  REQUEST_START: 'APP.TAXPAYER.INN.SEARCH.REQUEST_START',
  REQUEST_SUCCESS: 'APP.TAXPAYER.INN.SEARCH.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.TAXPAYER.INN.SEARCH.REQUEST_FAILURE',
  RESET: 'APP.TAXPAYER.INN.SEARCH.RESET',
};

export function startRequest(inn) {
  return {
    type: actionTypes.REQUEST_START,
    payload: inn,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
